import { BaseModel } from "sjs-base-model";

export default class UtenteModel extends BaseModel {
    public readonly idUtente: number = 0;
    public readonly nome: string = "";
    public readonly cognome: string = "";
    public readonly email: string = "";
    public readonly idAzienda: number = 0;
    public readonly nomeAzienda: string = "";

    constructor(data: Partial<UtenteModel>) {
        super();

        this.update(data);
    }
}
